module.exports = __webpack_public_path__ + "img/modal-left-2.8e7fb77d.png";